import React, {Component} from "react"

import {Button} from "reactstrap";
import {SpinnerSecondaryButton} from "./SpinnerSecondaryButton";
import {APIClient} from "../utils/APIClient";
import {API_URL} from "../settings/local_settings";
import { withTranslation } from 'react-i18next';

export class CSVFileInputClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url:null,
            importing: false,
            error: null
        }

        this.handleUrlOnChange = this.handleUrlOnChange.bind(this);
        this.handleImport = this.handleImport.bind(this);
    }

    handleUrlOnChange(event) {
        this.setState({
            url: event.target.value
        });
    };

    handleImport() {
        this.setState({
            importing: true
        });

        this.getHeadersFromCSVFileUrl();
    }

    renderImportButton() {
        const { t } = this.props;
        if(this.state.importing === true) {
            return <SpinnerSecondaryButton style={{minWidth:"115px"}} className="btn btn-secondary"/>;
        }

        return <Button key="button" className="btn btn-secondary" onClick={this.handleImport}  style={{height: "2.7em", minWidth:"115px"}}>{t('csv_file_input.import')}</Button>
    }

    render() {
        return [
            null,
            <div className="input-group-append">
                <input onChange={this.handleUrlOnChange} name="url" type="text" value={this.state.url} className="mr-2"/>
                {this.renderImportButton()}
            </div>
        ]
    }

    // API calls

    getHeadersFromCSVFileUrl() {
        const { t } = this.props;
        new APIClient(API_URL + `check-csv-file-url/`).call('PUT', {"csv_file_url": this.state.url})
            .then((response) => {
                this.setState({
                    importing:false
                });

                if (response.status === 'OK') {
                    const headers = response.data.headers;
                    const columnMapping = response.data.column_mapping;
                    const currency = response.data.currency;
                    const timezone = response.data.timezone;
                    const dateFormat = response.data.date_format;
                    this.props.onImport(this.state.url, headers, columnMapping, currency, timezone, dateFormat);
                } else if (response.status === 'URL_IS_INVALID') {
                    alert(t('csv_file_input.url_invalid'));
                } else if (response.status === 'CAN_NOT_ACCESS_URL') {
                    alert(t('csv_file_input.cannot_access_url'));
                } else {
                    alert(response.error_message)
                }
            });
    }
}

export const CSVFileInput = withTranslation()(CSVFileInputClass);
export default CSVFileInput;
